import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { EndpointsService } from './endpoints.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TermsCondsService {

  constructor(
    private httpService: HttpService,
    private endpoints: EndpointsService
  ) { }

  checkTermsAndCond(uid: string, type: string): Observable<any> {
    return this.httpService.get(this.endpoints.checkTermsAndCond.replace('{uid}', uid).replace('{type}', type));
  }

  documentTermsAndCond(type: string): Observable<any> {
    return this.httpService.get(this.endpoints.documentTermsAndCond.replace('{type}', type));
  }

  acceptTermsAndCond(body: any): Observable<any> {
    return this.httpService.post(this.endpoints.acceptTermsAndCond, body);
  }
}
